import React from 'react'
import { NutritionMealItem } from '@store/Nutrition/types'
import { useNutritionStore } from '@store/Nutrition'
import './meal-details.css'

interface MealDetailsProps {
  items: NutritionMealItem[]
}

function MealDetails({ items }: MealDetailsProps) {
  const { getIconUrl } = useNutritionStore.getState()

  const formatNumber = (value: number): string => {
    const formatted = value.toFixed(1)
    return formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted
  }

  return (
    <div className='meal-details'>
      {items.map((item, index) => (
        <div key={index} className='meal-details__item'>
          <img
            src={getIconUrl(item.icon_id, 360)}
            alt={item.name}
            className='meal-details__image'
          />

          <div className='meal-details__content'>
            <div className='meal-details__name'>
              {item.name
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')}
            </div>

            <div className='meal-details__row'>
              <div className='meal-details__portion'>
                {item.serving_quantity} {item.serving_unit} (
                {formatNumber(item.weight_grams)} g)
              </div>

              <div className='meal-details__nutrients'>
                <div className='meal-details__nutrient meal-details__nutrient--calories'>
                  {formatNumber(item.calories)}{' '}
                  <span className='meal-details__unit'>cal</span>
                </div>
                <div className='meal-details__nutrient meal-details__nutrient--carbs'>
                  {formatNumber(item.carbs)}{' '}
                  <span className='meal-details__unit'>g</span>
                </div>
                <div className='meal-details__nutrient meal-details__nutrient--protein'>
                  {formatNumber(item.protein)}{' '}
                  <span className='meal-details__unit'>g</span>
                </div>
                <div className='meal-details__nutrient meal-details__nutrient--fat'>
                  {formatNumber(item.fat)}{' '}
                  <span className='meal-details__unit'>g</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MealDetails
